import { render, staticRenderFns } from "./CertificateManage.vue?vue&type=template&id=29136d44&scoped=true"
import script from "./CertificateManage.vue?vue&type=script&lang=js"
export * from "./CertificateManage.vue?vue&type=script&lang=js"
import style0 from "./CertificateManage.vue?vue&type=style&index=0&id=29136d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29136d44",
  null
  
)

export default component.exports